import { render, staticRenderFns } from "./questionModal.vue?vue&type=template&id=0add2e34&scoped=true&"
import script from "./questionModal.vue?vue&type=script&lang=js&"
export * from "./questionModal.vue?vue&type=script&lang=js&"
import style0 from "./questionModal.vue?vue&type=style&index=0&id=0add2e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0add2e34",
  null
  
)

export default component.exports